import { useCartsMutations } from '../api/hooks/vendor/carts/use-carts-mutations';
import useWorkflowChannel from '../websocket/hooks/use-workflow-channel';
import { WorkflowChannelPayload } from '../websocket/types';

export const useOrderWorkflowHandler = () => {
  const { updateQueryData } = useCartsMutations();

  const handleShopCancellation = (message: WorkflowChannelPayload) => {
    switch (message.status) {
      case 'completed':
        updateQueryData(
          {
            id: message.order_id,
            status: 'canceled',
          },
          true,
        );
        break;

      case 'failed':
        updateQueryData(
          {
            id: message.order_id,
            pending_cancellation: false,
          },
          true,
        );
        break;

      default:
        // When the status 'pending', do nothing.
        break;
    }
  };

  useWorkflowChannel('ShopCancellationWorkflow', handleShopCancellation);
};
